import { FieldGeneratorFieldType } from "../FormFields/FieldGenerator/FieldGenerator"
import { recordTypes } from "./PropertyForm/PropertyFormConstants"

export const imageGalleryFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'text',
    fieldLabel: 'Image Url',
    placeholder: 'Image Url',
    fieldName: 'url'
  },
  {
    fieldType: 'text',
    fieldLabel: 'Image Title',
    placeholder: 'Image Title',
    fieldName: 'title'
  },
  {
    fieldType: 'text',
    fieldLabel: 'Image Description',
    placeholder: 'Image Description',
    fieldName: 'description'
  },
  {
    fieldType: 'text',
    fieldLabel: 'Thumb Url',
    placeholder: 'Thumb Url',
    fieldName: 'thumbUrl'
  }
]

export const linkedServicesFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'text',
    fieldLabel: 'Linked Service Name',
    placeholder: 'Linked Service Name',
    fieldName: 'linkedService'
  },
  {
    fieldType: 'textarea',
    fieldLabel: 'Linked Service Id',
    placeholder: 'Linked Service Id',
    fieldName: 'linkedServiceId'
  }
]

export const registrationRecordsFieldValues: FieldGeneratorFieldType[] = [
  {
    fieldType: 'select',
    fieldLabel: 'Record Type',
    placeholder: 'Record Type',
    fieldName: 'recordType',
    options: recordTypes
  },
  {
    fieldType: 'text',
    fieldLabel: 'Record Value',
    placeholder: 'Record Value',
    fieldName: 'value'
  },
  {
    fieldType: 'date',
    fieldLabel: 'Expiration Date',
    placeholder: 'Expiration Date',
    fieldName: 'expiration'
  }
]  